import React, { useEffect, useState } from "react";
import WindowContainer from "../../common/WindowContainer";
import { fetchProjects } from "../../../utils/ContentfulClient";
import { renderRichText } from "../../../utils/renderRichText";
import Button from "../../common/Button";
import { isEven } from "../../../utils/helpers";
import Tag from "../../common/Tag";

// interface IProject {
//   name?: string;
//   link?: string;
//   description?: Array<object>;
//   orientation?: "left" | "right";
//   images: string[];
// }

const Projects = () => {
  const [projects, setProjects] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const getProjects = async () => {
      const contentfulProjects = await fetchProjects();
      setProjects(contentfulProjects);
      setLoading(false);
    };

    getProjects();
  }, []);

  return (
    <div
      id="projectsSection"
      className="rounded-3xl lg:p-24 bg-black/50 flex flex-col items-center py-12 px-8"
    >
      <p className="font-bold text-xl text-center w-full"> {">"} MY PROJECTS</p>
      <p className="w-full text-center mb-12 md:mb-20">
        Check out what I've been working on!
      </p>

      {loading ? (
        <p className="text-center text-white">Loading Projects...</p>
      ) : (
        projects.map((project, index) =>
          isEven(index) ? (
            <div
              key={index}
              className="flex flex-col lg:flex-row lg:m-2 max-w-[80rem] m-[0 auto] group"
            >
              {/* Hide separator on first entry */}
              {index !== 0 && (
                <hr className="w-auto h-1 my-8 bg-backgroundDark border-0 rounded-sm" />
              )}
              <div className="lg:group-hover:-translate-x-16 transition-transform duration-500 ease-in-out will-change-transform flex flex-col text-left lg:text-right lg:relative lg:w-1/2 lg:-right-20 z-50 md:px-20 lg:px-0 lg:pt-32 lg:pb-20 lg:items-end ">
                {project.isCurrent && (
                  <span className="uppercase">Current</span>
                )}
                <h4 className="text-secondary font-bold text-lg lg:text-xl">
                  {project.name}
                </h4>
                <p className="text-gray-300 text-sm lg:text-lg">
                  {renderRichText(project.description)}
                </p>
                {!project.isCompleted && (
                  <span className="text-xs italic mt-6">
                    This is a work in progress - as soon as the website is
                    completed, a link will be added here! <br />
                    <br />
                    If you have any questions regarding this project, feel free
                    to reach out.
                  </span>
                )}
                <div className="my-4 gap-4 flex flex-wrap justify-start">
                  {project.technologies.map((t: string, index: number) => (
                    <Tag text={t} key={index} />
                  ))}
                </div>

                <div className="md:hidden">
                  {project.images.map((img: string) => (
                    <div
                      key={img}
                      className="flex justify-center rounded-xl md:rounded-3xl overflow-hidden mb-2"
                    >
                      <img src={img} alt="Project" className="w-full h-full" />
                    </div>
                  ))}
                </div>
                {project.link && project.isCompleted && (
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noreferrer"
                    className="mb-4"
                  >
                    <Button label="See more" onClick={() => {}} />
                  </a>
                )}
              </div>
              <div className="lg:group-hover:translate-x-16 transition-transform duration-500 ease-in-out will-change-transform hidden md:flex flex-col col-2 px-10 md:px-20 lg:px-0 w-full lg:w-1/2 rounded-[3rem] bg-gradient-to-r from-black/[0.8]">
                <WindowContainer type="fullsize">
                  {project.images.map((img: string) => (
                    <div
                      key={img}
                      className="lg:group-hover:-translate-x-8 transition-transform duration-500 ease-in-out will-change-transform ml-16 relative rounded-3xl overflow-hidden"
                    >
                      <img
                        src={img}
                        alt="Project"
                        className="w-full h-full object-cover"
                      />

                      <div className="absolute inset-0  bg-gradient-to-r from-black/[0.8] pointer-events-none" />
                    </div>
                  ))}
                </WindowContainer>
              </div>
            </div>
          ) : (
            <div
              key={project.name}
              className="flex flex-col lg:flex-row-reverse lg:m-2 w-full max-w-[80rem] m-[0 auto] group"
            >
              <hr className="w-auto h-1 my-8 bg-backgroundDark border-0 rounded-sm md:my-10 " />
              <div className="lg:group-hover:translate-x-16 transition-transform duration-500 ease-in-out will-change-transform flex flex-col text-left lg:relative lg:w-1/2 lg:right-20 z-40 md:px-20 lg:px-0 lg:pt-32 lg:pb-20 lg:items-start">
                <h4 className="text-secondary font-bold text-lg lg:text-xl">
                  {project.name}
                </h4>
                <p className="text-gray-300 text-sm lg:text-lg">
                  {renderRichText(project.description)}
                </p>
                <div className="my-4 gap-4 flex w-full flex-wrap justify-start">
                  {project.technologies.map((t: string, index: number) => (
                    <Tag text={t} key={t} />
                  ))}
                </div>

                <div className="md:hidden">
                  {project.images.map((img: string) => (
                    <div
                      key={img}
                      className="flex justify-center rounded-xl md:rounded-3xl overflow-hidden mb-2"
                    >
                      <img src={img} alt="Project" className="w-full h-full" />
                    </div>
                  ))}
                </div>
                {project.link && project.isCompleted && (
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noreferrer"
                    className="mb-4"
                  >
                    <Button label="See more" onClick={() => {}} />
                  </a>
                )}
              </div>
              <div className="lg:group-hover:-translate-x-16 transition-transform duration-500 ease-in-out will-change-transform hidden md:flex flex-col col-2 px-10 md:px-20 lg:px-0 w-full lg:w-1/2 rounded-[3rem]  bg-gradient-to-l from-black/[0.8]">
                <WindowContainer type="fullsize">
                  {project.images.map((img: string) => (
                    <div
                      key={img}
                      className="lg:group-hover:translate-x-8 transition-transform duration-500 ease-in-out will-change-transform mr-16 relative rounded-3xl overflow-hidden"
                    >
                      <img
                        src={img}
                        alt="Project"
                        className="w-full h-full object-cover"
                      />

                      <div className="absolute inset-0  bg-gradient-to-l from-black/[0.8] pointer-events-none" />
                    </div>
                  ))}
                </WindowContainer>
              </div>
            </div>
          )
        )
      )}
    </div>
  );
};

export default Projects;
